module.exports = __webpack_public_path__ + "img/tarjeta_servicios_oficina_referencia.ca7cc362.jpg";